import { useEffect, useState, useCallback } from "react";
import Modal from "../../Components/Base/Modal";
import { parseInput } from "../../Components/Constants/AppConstant";
import {
  campaignsApplicationService,
  influencerlistService,
} from "../../Services";
import Lottie from "lottie-react";
import check from "../../assets/Svgs/animationJson/check.json";

export default function AddInviteInfluencer(props) {
  console.log("props", props);
  const { toastList, setToastList } = props;
  const [isLoadedList, setIsLoadedList] = useState(false);
  const [listDetails, setListDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [addingToList, setAddingToList] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedInfluencerList, setSelectedInfluencerList] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectDesc] = useState("");
  const [list, setList] = useState([]);
  const [invitedCampaign, setInvitedCampaign] = useState([]);
  const [loadingInvited, setLoadingInvited] = useState(false);

  const searchText = "";
  const pageSize = 10;
  const page = 1;

  const addToast = useCallback(
    (data) => {
      const newToastList = [...toastList];
      newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
      setToastList(newToastList);
    },
    [toastList, setToastList]
  );

  const handleInvite = async () => {
    if (!selectedInfluencerList) return;
    setAddingToList(true);
    try {
      const payload = {
        list_id: selectedInfluencerList.id,
      };
      const res = await campaignsApplicationService.PostInvites(
        props.id,
        payload
      );
      if (res.success === true) {
        // addToast({
        //   error: false,
        //   msg: res.message || "Invites sent successfully",
        // });
        setShowSuccess(true);
        setSearchTerm("");
        setSelectedInfluencerList(null);
        setListDetails([]);
        setTimeout(() => {
          props.close();
        }, 2000);
      } else {
        addToast({
          error: true,
          msg: res.message,
        });
      }
    } catch (err) {
      if (err.apiResponseStatus !== 404) {
        let error = parseInput(err.message);
        addToast({
          error: true,
          msg: error.message,
        });
      }
    } finally {
      setAddingToList(false);
    }
  };

  const fetchInvitedInfluencers = async () => {
    setLoadingInvited(true);
    try {
      const res = await campaignsApplicationService.getInvite(props.id);
      if (res?.success === true) {
        setInvitedCampaign(res?.data);
      }
    } catch (err) {
      if (err.apiResponseStatus !== 404) {
        console.log(err.message);
      }
    } finally {
      setLoadingInvited(false);
    }
  };

  useEffect(() => {
    if (props.id) {
      fetchInvitedInfluencers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  const fetchInfluencerDetails = async () => {
    setIsLoadedList(true);
    try {
      const res = await influencerlistService.getAllInfluencerOfList(
        selectedInfluencerList.id,
        {
          page: page,
          pageSize,
        }
      );
      if (res.success === true) {
        setListDetails(res?.data?.influencers?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadedList(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      let filterString = "";
      if (searchText !== "" && selectDesc !== "") {
        filterString += "&search=" + searchText;
      }
      try {
        const res = await influencerlistService.getAllList({
          page: page,
          pageSize,
          filter: filterString,
        });
        if (res.success === true) {
          setList(res.data.data);
        }
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const filteredList =
    list?.filter((list) =>
      list?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };

  useEffect(() => {
    if (selectedInfluencerList) {
      fetchInfluencerDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInfluencerList]);

  return (
    <>
      <Modal addClass="modalCamp" close={props.close}>
        <div className="mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
          {showSuccess && (
            <div className="absolute inset-0 bg-white z-50 flex items-center justify-center">
              <Lottie
                animationData={check}
                style={{ width: 200, height: 200 }}
              />
            </div>
          )}
          {/* Header */}
          <div className="p-6 bg-green-100 border-b border-gray-100">
            <div className="flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-800">
                  Select Influencer List to Invite
                </h2>
              </div>
            </div>
          </div>

          {/* Searchable Dropdown and Invite Button */}
          <div className="p-5 bg-gray-50 border-b border-gray-100">
            <div className="flex gap-3 items-start">
              <div className="relative flex-1">
                <div
                  className="block w-full pl-10 pr-10 py-3 border border-gray-200 rounded-xl bg-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg
                      className="h-5 w-5 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                  <input
                    type="text"
                    className="w-full outline-none bg-transparent"
                    placeholder="Search influencer list..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setIsDropdownOpen(true);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center gap-2">
                    {selectedInfluencerList && (
                      <svg
                        className="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedInfluencerList(null);
                          setSearchTerm("");
                        }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    )}
                    <svg
                      className={`h-5 w-5 text-gray-400 transition-transform ${
                        isDropdownOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </div>
                {isDropdownOpen && (
                  <div
                    className="absolute z-10 w-full mt-2 bg-white border border-gray-200 rounded-xl shadow-lg !max-h-40 overflow-y-auto"
                    style={{
                      scrollbarWidth: "thin",
                      scrollbarColor: "#e5e7eb transparent",
                    }}
                  >
                    {filteredList.length > 0 ? (
                      filteredList.map((list) => (
                        <div
                          key={list.id}
                          className="flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                          onClick={() => {
                            setSelectedInfluencerList(list);
                            setSearchTerm(list.name);
                            setIsDropdownOpen(false);
                          }}
                        >
                          <div className="flex-shrink-0 h-10 w-10 rounded-lg overflow-hidden bg-gray-200">
                            <img
                              className="h-full w-full object-cover"
                              src={
                                list.image_url ||
                                `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                              }
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                              }}
                              alt={list.name}
                            />
                          </div>
                          <div className="ml-3 flex-1">
                            <div className="font-medium text-gray-900">
                              <span className="font-bold">
                                {list.name?.[0]?.toUpperCase() +
                                  list.name?.slice(1)}
                              </span>
                              <p className="text-gray-500">
                                {list.count} influencer
                              </p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="p-4 text-center text-gray-500">
                        No campaigns found
                      </div>
                    )}
                  </div>
                )}
              </div>
              <button
                className="px-6 py-3 bg-green-600 text-white rounded-xl hover:bg-green-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors whitespace-nowrap"
                onClick={handleInvite}
                disabled={!selectedInfluencerList || addingToList}
              >
                {addingToList ? "Processing..." : "Invite"}
              </button>
            </div>
          </div>

          <p className="px-6 bg-gray-50 font-semibold text-gray-700">
            Invited Influencers
          </p>
          <div
            className="max-h-96 overflow-y-auto p-5 bg-gray-50"
            style={{
              scrollbarWidth: "thin",
              scrollbarColor: "#e5e7eb transparent",
            }}
          >
            {loadingInvited ? (
              <div className="text-center text-gray-500 py-8">Loading...</div>
            ) : (
              invitedCampaign?.length > 0 &&
              invitedCampaign?.map((list) => (
                <div
                  key={list.user_id}
                  className="flex items-center p-4 mb-3 bg-white rounded-xl shadow-sm border border-gray-200 cursor-pointer hover:border-green-400 hover:shadow-md transition-all duration-200 group"
                  style={{
                    opacity: addingToList ? 0.6 : 1,
                    pointerEvents: addingToList ? "none" : "auto",
                  }}
                >
                  <div className="flex-shrink-0 h-12 w-12 rounded-xl overflow-hidden bg-gray-200 border border-gray-300">
                    <img
                      className="h-full w-full object-cover"
                      src={
                        list.profile_img && list.profile_img !== ""
                          ? list.profile_img
                          : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                      }}
                      alt={list.displayname}
                    />
                  </div>
                  <div className="ml-4 flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 truncate group-hover:text-green-700 transition-colors">
                      {list.displayname}
                    </h3>
                  </div>
                  <div className="shadow-md ml-2 px-3 py-1 inline-flex items-center gap-2 border-green-50 bg-gray-50 text-gray-500 italic  hover:border-gray-400  hover:from-gray-200 hover:to-gray-300  hover:text-gray-800 hover:shadow-[0_2px_12px_-3px_rgba(0,0,0,0.15)] transition-all duration-200 text-sm font-medium rounded-full backdrop-blur-sm cursor-default">
                    <span className="font-semibold italic">Invited</span>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </Modal>
    </>
  );
}
